/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Aria_Open_MenuInputs */

const nl_common_aria_open_menu = /** @type {(inputs: Common_Aria_Open_MenuInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Menu openen`)
};

/**

* @param {Common_Aria_Open_MenuInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const common_aria_open_menu = /** @type {((inputs?: Common_Aria_Open_MenuInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Aria_Open_MenuInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_common_aria_open_menu(inputs)
});
export { common_aria_open_menu as "common.aria.open_menu" }